export default [
    {
        type: "b-form-select",
        margin: true,
        showLabel: true,
        label: "Personal Type",
        options: [
            { value: 0, text: "All" },
            { value: 1, text: "Employee" },
            { value: 2, text: "Driver" },
            { value: 4, text: "Stevedore" },
        ],
        model: null,
        cols: 6,
    },
    {
        type: "b-form-select",
        margin: true,
        showLabel: true,
        label: "Viatic",
        options: [
            { value: 0, text: "All" },
            { value: 1, text: "Apply" },
            { value: 2, text: "Not Apply" },
        ],
        model: null,
        cols: 6,
    },
];